import { applyMiddleware, legacy_createStore as createStore } from "redux";
import thunk from "redux-thunk";
import allReducers from "./reducers/index";
import { composeWithDevTools } from "redux-devtools-extension";

export const configStore = createStore(
  allReducers,
  composeWithDevTools(applyMiddleware(thunk))
  //window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // for redux devtools, you can get in https://github.com/zalmoxisus/redux-devtools-extension
);
